'use client';

import Image from 'next/image';
import HIHLink from '../base/Link';
import { NewTabHint } from '../base/NewTabHint';
import {
  MATOMO_ACTIONS,
  MATOMO_CATEGORIES,
  MATOMO_NAMES,
  trackMatomoEvent,
} from '@/utils/matomo';
import styles from './EventLocationLink.module.scss';

export function EventLocationLink({
  href,
  locationName,
}: {
  href: string;
  locationName: string;
}) {
  return (
    <HIHLink
      href={href}
      className={styles.locationLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        trackMatomoEvent(
          MATOMO_CATEGORIES.INTERACTIONS,
          MATOMO_ACTIONS.LOCATION_CLICK,
          MATOMO_NAMES.EVENT_LOCATION_CLICK,
        )
      }
    >
      <Image src="/icons/icon-map.svg" width={24} height={24} alt="Ort" />
      {locationName}
      <NewTabHint />
      <Image
        src="/icons/icon-arrow-right-2.svg"
        width={24}
        height={24}
        className={styles.linkIcon}
        alt=""
      />
    </HIHLink>
  );
}
